import React from "react";
import { XCircle } from "lucide-react";
import { POCancellationDetails } from "src/types";
import { CollapsibleSection } from "src/components/ui/collapsible";

interface PurchaseOrderCancellationSectionProps extends Partial<POCancellationDetails> {}

const PurchaseOrderCancellationSection: React.FC<PurchaseOrderCancellationSectionProps> = ({
  cancellationReason,
  cancelledBy,
  cancelledByEmail
}) => {
  if (!cancellationReason) {
    return null;
  }

  return (
    <div className="bg-white border border-error-200 rounded-xl shadow-soft overflow-hidden">
      <CollapsibleSection
        initiallyOpen={true}
        title={
          <h3 className="text-lg font-semibold text-error-800 flex items-center">
            <XCircle className="w-5 h-5 mr-2 text-error-600" />
            Cancellation Details
          </h3>
        }
      >
        <div className="p-6 space-y-4">
          {/* Cancellation Reason */}
          <div className="bg-error-50 border border-error-200 rounded-lg p-4">
            <p className="text-sm font-semibold text-error-800 mb-2">Reason</p>
            <p className="text-sm text-error-700 leading-relaxed">{cancellationReason}</p>
          </div>

          {/* Cancelled By Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-secondary-50 rounded-lg p-4">
              <p className="text-xs font-semibold text-secondary-700 uppercase tracking-wide mb-2">Cancelled By</p>
              <p className="text-sm font-medium text-secondary-900">{cancelledBy}</p>
            </div>
            {cancelledByEmail && (
              <div className="bg-secondary-50 rounded-lg p-4">
                <p className="text-xs font-semibold text-secondary-700 uppercase tracking-wide mb-2">Email</p>
                <p className="text-sm font-medium text-secondary-900">{cancelledByEmail}</p>
              </div>
            )}
          </div>
        </div>
      </CollapsibleSection>
    </div>
  );
};

export { PurchaseOrderCancellationSection };
